module.exports = __webpack_public_path__ + "img/icon_xiaochengxu.719b078a.png";